module.exports = __webpack_public_path__ + "static/media/in-store.15212ebe.svg";